import React, {useEffect, useState} from 'react';
import {FabProps} from '@mui/material';

import Icon from 'presentation/icons';
import {StyledFab} from './styles';

export function ScrollToTop({...fabProps}: FabProps) {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const contentContainer = document.getElementById('content-container');

		const handleScroll = () => {
			if (contentContainer) {
				setIsVisible(contentContainer.scrollTop > 100);
			}
		};

		contentContainer?.addEventListener('scroll', handleScroll);

		return () => {
			contentContainer?.removeEventListener('scroll', handleScroll);
		};
	}, []);

	function handleClick() {
		const topRef = document.getElementById('content-container');
		if (topRef) {
			topRef.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}

	if (!isVisible) return null;

	return (
		<StyledFab color="primary" size="small" onClick={handleClick} {...fabProps}>
			<Icon name="arrow-up-filled" />
		</StyledFab>
	);
}
